<template>
  <SectionContentLayout
    :state="state"
    content_class="contacts-person"
    invalid_text='contacts.person.invalid'
    invalid_icon='fas fa-address-card'
    error_text="contacts.list.error"
  >
    <template #close>
      <ActionButton
          @click="onActionClose()"
          class="close"
          icon="fas fa-times-circle"
          v-tooltip='"global.actions.close"'
      />
    </template>

    <template #header>
        <ContentTitle
          title="contacts.person_title"
        />
    </template>

    <template #actions_success>
        <ActionButton
          v-if="person.email"
          @click="onActionToSendMail()"
          v-tooltip='"contacts.actions.send_mail"'
          icon='fas fa-pencil-alt'
        />
        <RouterButton
          :link="'/contacts/person/edit/' + person.id"
          v-tooltip='"contacts.actions.edit_person"'
          icon='fas fa-user-edit'
        />
        <ActionButton
          @click="onAddToGroup()"
          v-tooltip='"contacts.actions.add_to_group"'
          icon='fas fa-users'
        />
        <ActionButton
          @click="onPersonDelete()"
          v-tooltip='"contacts.actions.delete"'
          icon='fas fa-trash-alt'
        />
    </template>

    <template #content_success>
        <div class="contact" v-if="person.id">
            <p class="name">
                <small>{{Language.say('contacts.form.name')}}</small>
                <span>{{person.name}}</span>
            </p>
            <p class="email" v-if="person.email">
                <small>{{Language.say('contacts.form.email')}}</small>
                <span><a :href="'mailto:' + person.email">{{person.email}}</a></span>
            </p>
            <p class="mobile-phone" v-if="person.mobile_phone">
                <small>{{Language.say('contacts.form.mobile_phone')}}</small>
                <span><a :href="'tel:' + person.mobile_phone">{{person.mobile_phone}}</a></span>
            </p>
            <p class="home-address" v-if="person.home_address">
                <small><small>{{Language.say('contacts.form.home_address')}}</small></small>
                <span>{{person.home_address}}</span>
            </p>
            <p class="company" v-if="person.company">
                <small>{{Language.say('contacts.form.company')}}</small>
                <span>{{person.company}}</span>
            </p>
            <p class="birth-date" v-if="person.birth_date">
                <small>{{Language.say('contacts.form.birth_date')}}</small>
                <span>{{person.birth_date}}</span>
            </p>
            <p class="notes" v-if="person.notes">
                <small>{{Language.say('contacts.form.notes')}}</small>
                <span>{{person.notes}}</span>
            </p>
        </div>

        <div class="top-space" v-if="person.groups.length">
            <p>{{Language.say('contacts.person.groups')}}</p>
            <ul class="person-groups">
                <li v-for="group in person.groups" :key=group.id>
                    <router-link :to='"/contacts/group/info/" + group.id'>
                        <i class="fas fa-users"></i>
                        {{group.name}}
                    </router-link>
                    <ActionButton
                        @click="onGroupRemove(group)"
                        v-tooltip='"contacts.actions.remove_from_group"'
                        icon="fas fa-trash-alt"
                        class="clear main-action"
                        :loading="delete_loading[group.id]"
                    />
                </li>
            </ul>
        </div>
    </template>
  </SectionContentLayout>
</template>

<script setup>
  import {ref}                        from 'vue';
  import {onBeforeMount, onUnmounted} from 'vue';
  import {defineProps}                from 'vue';
  import {useRoute,useRouter}         from 'vue-router';
  import ActionButton                 from '@/vue/Elements/Buttons/ActionButton.vue';
  import RouterButton                 from '@/vue/Elements/Buttons/RouterButton.vue';
  import ContentTitle                 from '@/vue/Elements/Content/ContentTitle.vue';
  import SectionContentLayout         from '@/vue/Layouts/Sections/SectionContentLayout.vue';
  import Language                     from '@/js/Shared/Language/Language';
  import ContactsController           from '@/js/Contacts/ContactsController';
  import ContactsSelectionCollection  from '@/js/Contacts/Collections/ContactsSelectionCollection';

  const props = defineProps({
    contacts_view : {}
  })

  const route               = useRoute();
  const router              = useRouter();
  const contacts_controller = ContactsController
  const dummy_selection     = new ContactsSelectionCollection()
  const delete_loading      = ref({});
  const person              = ref();
  const state               = ref('loading');

  onBeforeMount(async () => {
    contacts_controller.state.on('fetch_foreground', 'success', onLoad);
  })

  onUnmounted(async () => {
    contacts_controller.state.destroy('fetch_foreground', 'success', onLoad);
  })

  const onLoad = () => {
    setPerson();
    setState();
    setDummySelection();
  }

  const onActionClose = () => {
    close();
  }

  const onAddToGroup = () => {
    props.contacts_view.openContactsSelectedToGroup(dummy_selection);
  }

  const onPersonDelete = () => {
    props.contacts_view.openContactsDelete(dummy_selection);
  }

  const onGroupRemove = async (group) => {
    setDeleteLoading(group.id);
    await contacts_controller.removePersonsFromGroup(group, [person.value.id])
    removeDeleteLoading(group.id);
  }

  const setPerson = () => {
    person.value = contacts_controller.contacts.all.get(route.params.contact_id);
  }

  const setState = () => {
    state.value = (!person.value.id) ? 'invalid' : contacts_controller.state.events['fetch_foreground'];
  }

  const setDummySelection = () => {
    dummy_selection.add(person.value);
  }

  const setDeleteLoading = (group_id) => {
    delete_loading.value[group_id] = true;
  }

  const removeDeleteLoading = (group_id) => {
    delete delete_loading.value[group_id];
  }

  const close = () => {
    router.push('/contacts');
  }

  const onActionToSendMail = () => {
    props.contacts_view.onActionToSendMail([person.value]);
  }
</script>
